import { render, staticRenderFns } from "./MypageTicketToggleIconParts.vue?vue&type=template&id=b4600efa&scoped=true"
import script from "./MypageTicketToggleIconParts.vue?vue&type=script&lang=ts"
export * from "./MypageTicketToggleIconParts.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketToggleIconParts.vue?vue&type=style&index=0&id=b4600efa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4600efa",
  null
  
)

export default component.exports